export const white = '#ffffff';
export const black = '#222222';
export const darkgrey = '#414141';
export const grey = '#a0a0a0';
export const lightgrey = '#c1c1c1';
export const brand = '#ec691a';
export const background = '#fcfcfc';
export const blueish = '#d9dde4';
export const acceptGreen = '#009900';
export const warningred = '#d0021b';
export const grey94 = '#f0f0f0';
export const nobel = '#989898';
export const darkgreen = '#3a5939';
export const shadegreen = '#5a735a';
export const brown = '#7A5B2D';
export const softgrey = '#f4f5f7';
export const uiwarning = '#ee1b34';
export const statusGreen = '#4caf50';
export const statusOrange = '#fe9800';
export const statusRed = '#ee1b34';
export const tabsBorder = '#e0e0e0';
export const tabsRowHover = '#e6e6e6';
export const filtersGrey54 = 'rgba(0, 0, 0, 0.54)';
export const filtersGrey01 = 'rgba(0, 0, 0, 0.1)';
export const filtersBackground = '#f5f5f5';
export const tableEvenRow = '#f5f5f5';
export const lightGrey = '#7b7b7b';
export const modalGrey = '#f5f5f5';
export const inactivePosition = '#a0a0a0';

export const inactive = '#dddddd';
export const defaultsearchcolor = '#bdbdbd';
export const divider = '#f6f6f6';
export const acceptgreen = '#009900';
export const statusbargreen = '#4caf50';
export const mark = '#ffef34';
export const positionbargreen = '#0cd90c';
export const positionbarred = '#fd6464';
export const yellow = '#fe9800';
export const normalgreen = '#188518';
export const hotkeyGrey = '#2e2e2e';
export const hotkeyGreyDisabled = 'rgba(46, 46, 46, 0.5)';
export const border = '#7e7e7e';
export const dot = '#979797';
export const borderDialog = '#dfdfdf';
export const vsColor = '#4e4e4e';
export const teamNameDialog = '#333';
export const noticeWarning = '#ee1b34';
export const reviewSubtitle = '#b7b7b7';
export const reviewBlue = '#2969c1';
export const reviewLine = '#d8d8d8';
export const reviewErrorBgOdd = '#e8d8e4';
export const reviewErrorBgEven = '#e2d3df';
export const borderColorNotes = '#e0e0e0';
export const highlightGradientBlueLight = '#449fff';
export const highlightGradientBlueDark = '#057dff';
export const cardBackground = '#f7f7f7';
export const gradientGreenLight = '#00c900';
export const gradientGreenDark = '#009900';
export const gradientYellowLight = '#ffc900';
export const gradientYellowDark = '#fe9800';
export const badgeShadow = '#e0e0e0';
export const newMark = 'rgba(236, 105, 26, 0.2)';
export const newPlayerBackground = '#F5F5F5';
export const tertiaryGrey = '#717171';
export const buttonLightGrey = '#f5f5f5';
export const badgeBackgroundColor = '#009688';
export const taggedWhite = '#e0e0e0';
export const dividerColor = '#e0e0e0';
export const autosaveInfoColor = '#7b7b7b';
export const saveButtonBackgroundColor = '#f5f5f5';
